import * as React from 'react';

import { DashboardMetricCardWrapper } from 'components/dashboard-metric-card';
import { useSubscribersCount } from 'store/apis';
import { DoughnutChart } from './doughnut-chart';

interface ChartTotalSubscribersProps {
  buildingId: number;
}

export const ChartTotalSubscribers = ({ buildingId }: ChartTotalSubscribersProps) => {
  const { data, isFetching } = useSubscribersCount({ buildingId });

  return (
    <DashboardMetricCardWrapper
      title="Total Subscribers"
      subtitle=""
      loading={isFetching}
      loadingText="Loading subscribers..."
    >
      <DoughnutChart data={data} value={data.datasets[0].data[0]} valueUnit="SUBSCRIBERS" />
    </DashboardMetricCardWrapper>
  );
};
